import { takeLatest, call, put } from 'redux-saga/effects';
import actionTypes from 'store/auth/actionTypes';
import api from 'store/api';
import { URL } from '../../../constants/url';

export function* refreshGen() {
  try {
    const refreshToken = localStorage.getItem('refreshToken');
    const res = yield call(api, {
      method: 'post',
      url: URL.REFRESH,
      data: {
        refresh_token: refreshToken,
      },
    });
    const { data } = res;
    localStorage.setItem('accessToken', data.access_token);
    localStorage.setItem('refreshToken', data.refresh_token);
    return data;
  } catch (e) {
    yield put({ type: actionTypes.LOGOUT });
    return null;
  }
}

export default function* listener() {
  yield takeLatest(actionTypes.REFRESH, refreshGen);
}
